import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/service/common.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-bus-packages',
  templateUrl: './bus-packages.component.html',
  styleUrls: ['./bus-packages.component.css']
})
export class BusPackagesComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  currentTour: any = {};

  constructor(private route: ActivatedRoute, private commonService: CommonService) {
    this.blockUI.start("Please Wait....");
    this.route.params.subscribe((result) => {
      let id = result.id;
      if (id) {
        let result = this.commonService.busPackagesArr.filter(bus => bus.id == id);
        if (result.length > 0) {
          this.currentTour = result[0];
          this.blockUI.stop();
          //location.reload();
        }        
      }
      console.log("currentTour", this.currentTour);
    }, (err) => (err) => this.errorHandler(err));
  }

  ngOnInit() {
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}
